import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=8f7c92f4&scoped=true&"
import script from "./TableCell.vue?vue&type=script&lang=js&"
export * from "./TableCell.vue?vue&type=script&lang=js&"
import style0 from "./TableCell.vue?vue&type=style&index=0&id=8f7c92f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7c92f4",
  null
  
)

/* custom blocks */
import block0 from "./TableCell.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f7c92f4')) {
      api.createRecord('8f7c92f4', component.options)
    } else {
      api.reload('8f7c92f4', component.options)
    }
    module.hot.accept("./TableCell.vue?vue&type=template&id=8f7c92f4&scoped=true&", function () {
      api.rerender('8f7c92f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PUI/Layout/TableCell.vue"
export default component.exports